/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var LogLevel;
(function (LogLevel) {
    LogLevel["info"] = "INFO";
    LogLevel["warn"] = "WARN";
    LogLevel["debug"] = "DEBUG";
    LogLevel["error"] = "ERROR";
    LogLevel["fatal"] = "FATAL";
})(LogLevel || (LogLevel = {}));
var LogType;
(function (LogType) {
    LogType["Default"] = "Default";
    LogType["Event"] = "Event";
    LogType["API"] = "API";
    LogType["Custom"] = "Custom";
})(LogType || (LogType = {}));

var Tracker = /** @class */ (function () {
    function Tracker(options) {
        var logStore = options.logStore;
        var logProject = options.logProject;
        var host = options.host || 'cn-hangzhou.log.aliyuncs.com';
        var project = options.projectName;
        if (logStore && logProject) {
            this.uri = "https://" + logProject + "." + host + "/logstores/" + logStore + "/track_ua.gif?APIVersion=0.6.0&__topic__=" + project;
        }
    }
    Tracker.prototype.log = function (b, level) {
        var _a;
        if (level === void 0) { level = LogLevel.info; }
        // 如果有报错也不抛错，不影响业务
        try {
            var body = typeof b === 'string'
                ? {
                    content: b,
                } : b;
            this.report(__assign(__assign({}, body), { logType: body.type || LogType.Default, logLevel: level, location: (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href }));
        }
        catch (error) {
            console.warn('An error occurred when push log: ' + error);
        }
    };
    Tracker.prototype.info = function (p) {
        this.log(p);
    };
    Tracker.prototype.warn = function (p) {
        this.log(p, LogLevel.warn);
    };
    Tracker.prototype.debug = function (p) {
        this.log(p, LogLevel.debug);
    };
    Tracker.prototype.error = function (p) {
        this.log(p, LogLevel.error);
    };
    Tracker.prototype.fatal = function (p) {
        this.log(p, LogLevel.fatal);
    };
    Tracker.prototype.report = function (payload) {
        if (!this.uri) {
            return;
        }
        var url = this.uri;
        Object.keys(payload).forEach(function (k) {
            url += "&" + k + "=" + encodeURIComponent(payload[k]);
        });
        new Image().src = url;
    };
    return Tracker;
}());

export { Tracker };
